import { AccountType } from '@/autogenerated/@prisma/prisma-mongo-client';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface AccountTypeBadgeProps {
  accountType?: AccountType | null;
  className?: string;
}

export function AccountTypeBadge({
  accountType,
  className,
}: AccountTypeBadgeProps) {
  return (
    <Badge
      className={cn(
        'px-2',
        accountType === AccountType.Refugee && 'bg-secondary-100',
        accountType === AccountType.Supporter && 'bg-tertiary-100',
        (accountType === null || accountType === undefined) && 'bg-primary-100',
        className
      )}
    >
      {accountType ?? 'N/A'}
    </Badge>
  );
}
